// Routing module for the file-review module.
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { FileReviewComponent } from './views/file-review/file-review.component';
import { JwtGuard } from '../shared/guards/jwt.guard';

const routes: Routes = [
  {
    path: 'file/:file_id',
    component: FileReviewComponent,
    canActivate: [JwtGuard]
  },
  {
    path: '**',
    redirectTo: 'file'
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class FileReviewRoutingModule {}
